const H1 = (props) => {
    return (
        <h1 className="font-extrabold text-xl p-2">{props.text}</h1>
    )
}

export default H1